import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  public fetchOrganizationsList(): Observable<any> {
    const url = this.apiUrl + 'Organization/FetchAllOrganizations';
    return this.http.get<any>(url);
  }

  public updateOrganization(user: any): Observable<any> {
    const url = this.apiUrl + 'Organization/UpdateOrganization';
    return this.http.post<any>(url, user);
  }

  public deleteOrganization(organizationId: string): Observable<any> {
    const url = this.apiUrl + 'Organization/DeleteOrganization/' + organizationId;
    return this.http.get<any>(url);
  }

  public deleteMultipleOrganizations(organizationIds: any[]): Observable<any> {
    const url = this.apiUrl + 'Organization/DeleteMultipleOrganizations/';
    return this.http.post<any>(url, organizationIds);
  }

  public addOrganization(organization): Observable<any> {
    const url = this.apiUrl + 'Organization/CreateOrganization';
    return this.http.post<any>(url, organization);
  }

  public searchGrid(searchTerm: string): Observable<any> {
    const url = this.apiUrl + 'Organization/GridSearch/' + searchTerm;
    return this.http.get<any>(url);
  }

  public getUserViewOrganizatons(userId){
    const url = this.apiUrl + 'Organization/GetUserViewOrganizatons/' + userId;
    return this.http.get<any>(url);
  }
}
